import Vue from 'vue';
import axios from 'axios';
import { message, notification } from 'ant-design-vue';

// eslint-disable-next-line no-unused-vars
let baseURL = process.env.VUE_APP_BASE_API;
if (window.location.origin === 'https://tianshu.map.qq.com' || window.location.origin === 'https://tianshutest.sparta.html5.qq.com') { // 嵌套走该接口
  baseURL = `/integral_mall${baseURL}`;
}

const config = {
  baseURL,
  // onUploadProgress: p => { return 100 * (p.loaded / p.total) }
  headers: {
    'Cache-Control': 'max-age=0',
    Pragma: 'no-cache',
    Accept: 'application/json',
    // 'Content-Type': 'application/x-www-form-urlencoded',
    'x-requested-with': 'fetch',
  },
};
// let CancelToken = axios.CancelToken
// let source = CancelToken.source()
const _axios = axios.create(config);

// let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// let removePending = (ever) => {
//   for (let p in pending) {
//     if (pending[p].u === (ever.url + '&' + ever.method)) {
//       // 当当前请求在数组中存在时执行函数体
//       pending[p].f() // 执行取消操作
//       pending.splice(p, 1) // 把这条记录从数组中移除
//     }
//   }
// }

// POST传参序列化(request 拦截器)
_axios.interceptors.request.use(
  (config) =>
    // ------------------------------------------------------------------------------------
    // removePending(config) // 在一个ajax发送前执行一下取消操作
    // // console.log('axios配置》》》》》', config)
    // config.cancelToken = new CancelToken((c) => {
    //   // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    //   pending.push({ u: config.url + '&' + config.method, f: c })
    // })
    // -----------------------------------------------------------------------------------------
    config,
  (error) => Promise.reject(error)
);

// 返回状态判断(response 拦截器)
_axios.interceptors.response.use(
  (res) => {
    // removePending(res.config)
    // 判断是否为mock数据;
    const isMock = res.request.match;
    let params = {};
    if (res.config.method === 'post') {
      params = typeof res.config.data === 'string'
        ? JSON.parse(res.config.data)
        : res.config.data;
    } else {
      params = res.config.params ? res.config.params : res.config.params;
    }
    isMock
      && window.clog(
        `%cMock%c ${res.config.url}`,
        'background:#666;color:#fff;padding:3px 5px; border-radius:5px;',
        'color: #09f;',
        params,
        res.data
      );
    // 下载文件时候对响应数据做些事
    if (res.headers['content-type'] === 'application/octet-stream') {
      return res;
    }
    if (res.data.type === 'video/mp4') {
      return res.data;
    }

    // 错误的情况
    if (res.data.iErrCode !== 0 && res.data.iErrCode !== undefined) {
      console.log('iErrCode !== 0', res);
      if (res.data.result) {
        message.error(`错误,code:${res.data.iErrCode},msg:${res.data.result.msg}`);
      } else {
        message.error(`错误,code:${res.data.iErrCode},msg:${res.data.data.msg}`);
      }
      return Promise.reject(res);
    }
    if (res.data.status === 406) {
      notification.error({
        // eslint-disable-next-line
        description: (h) => {
          return (
            <div>{
              (res.data.error_msg_list || []).map((item) => <div>{item}</div>)
            }</div>
          );
        },
      });
      return;
    }

    // 兼容不同返回格式
    if ((res.data.status && Number(res.data.status)) !== 200) {
      if (res.data.msg) {
        message.error(res.data.msg);
      }
    }
    return res.data.data;
  },
  (error) => {
    if (error && error.response && typeof error.response.data !== 'string') {
      // clog(error.response.data.iErrCode, '--------------error.response.data.iErrCode---------------')
      if (error.response.data.iErrCode === '403') {
        message.error(`${error.response.data.data.msg}`);
        return error.response.data.data;
      }

      // message.error(`服务器错误,code: ${error.config.url}, ${error.response.status}`)
      message.error(`${error.response.data.data.msg},${error.config.url}, ${error.response.status}`);

      console.log(
        'request-url-error:',
        `${error.response.data.data.msg},${error.config.url}, ${error.response.status}`
      );
    } else {
      console.log('request-url-error:', `${error}`);
    }

    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export const fetcher = ({ url, method, data, responseType }) => {
  data.t = new Date().getTime();
  if (method === 'get' || method === 'delete') {
    return _axios({
      url,
      method,
      params: data,
      responseType,
      cancelToken: data.cancelToken,
    });
  }
  return _axios({
    url,
    method,
    data,
    responseType,
    cancelToken: data.cancelToken,
  });
};
// export default _axios
